'use client';

import { Heading, Layout as LayoutBase, LayoutContainer, LoadingIndicator, LogoImage } from '@petsmart-ui/sparky';
import { usePathname, useRouter } from 'next/navigation';
import type { ReactNode } from 'react';
import { useEffect, useState } from 'react';

import '@/app/(auth)/layout.scss';

export default function AuthGuard({ children }: Readonly<{ children: ReactNode }>) {
    const router = useRouter();
    const pathname = usePathname() ?? '/';

    const [loading, setLoading] = useState(true);
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    useEffect(() => {
        const checkAuth = async () => {
            const res = await fetch('/api/auth/check-token');

            setIsAuthenticated(res.ok);
            setLoading(false);

            if (!res.ok && !pathname.startsWith('/auth')) {
                localStorage.setItem('okta-post-login-path', encodeURIComponent(pathname));

                router.replace('/auth/login');
            }
        };

        checkAuth();
    }, [router, pathname]);

    if (loading) {
        return (
            <LayoutBase className="auth-layout-base">
                <LayoutContainer className="auth-layout">
                    <LogoImage className="auth-layout__logo" />
                    <LoadingIndicator />
                    <Heading className="auth-layout__heading" size="title-lg" tagName="h2">
                        Loading...
                    </Heading>
                </LayoutContainer>
            </LayoutBase>
        );
    }

    if (!isAuthenticated && !pathname.startsWith('/auth')) {
        return null;
    }

    return <>{children}</>;
}
